import React, { Component } from 'react'
import {
  withStyles,
  makeStyles
} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import FormHelperText from '@material-ui/core/FormHelperText';

const CssTextField = withStyles({
    height: '100px',

  root: {
      
    '& label.Mui-focused': {
      color: '#242424',
      fontSize: '12px !important',
      fontWeight: '300 !important', //regular
      lineHeight: '12px !important'
    },
    
    '& .MuiFormLabel-root': {
      fontSize: '12px !important',
      fontWeight: '300 !important',
    }
  }
})(TextField);

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    height:'100px'
  }
}))



export default function CustomSmsField(props) {
  const classes = useStyles()

  return (
    <div className={classes.root} >
      <CssTextField
        multiline={props.multiline || false}
        required={props.required}
        inputProps={{ maxLength: props.maxLength || undefined }}
        //helperText={props.helperTextValue ? `${props.value.length}/${props.maxLength || 1000}` : false}
        fullWidth
        value={props.value}
        onChange={val => props.onInput(val)}
      />
      {
        props.required ?
        <FormHelperText>
          <div className="error-text">
            <ExclamationCircleOutlined className="error-text-icon" />please enter {props.label.toLowerCase()}
          </div>
        </FormHelperText>
        : null
      }
    </div>
  );
}
